import axios from '@/shared/utils/axios-init';
import sortFinanceData from '@/shared/utils/helpers/sortFinanceData';

const initialState = {
  financeData: [],
  baseCurrencyBalance: 0,
  quoteCurrencyBalance: 0,
};


const getters = {
  getFinanceData: state => state.financeData,
  getBaseCurrencyBalance: state => state.baseCurrencyBalance,
  getQuoteCurrencyBalance: state => state.quoteCurrencyBalance,
};

const mutations = {
  setFinanceData(state, data) {
    state.financeData = data;
  },
  setBaseCurrencyBalance(state, data) {
    state.baseCurrencyBalance = data;
  },
  setQuoteCurrencyBalance(state, data) {
    state.quoteCurrencyBalance = data;
  },
};

const actions = {
  async fetchFinanceData({ commit, rootState }) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.get('/finances', { headers: { Authorization: `Bearer ${token}` } });

      const financeData = data.data.finances;
      commit('setFinanceData', sortFinanceData(financeData));

      // set balance for currency pair
      const baseCurrencyBalance = financeData.find(cur =>
        cur.curr_code === rootState.dashboard.market.currenciesPair.baseCurrency);
      const quoteCurrencyBalance = financeData.find(cur =>
        cur.curr_code === rootState.dashboard.market.currenciesPair.quoteCurrency);
      commit('setBaseCurrencyBalance', +baseCurrencyBalance.amount);
      commit('setQuoteCurrencyBalance', +quoteCurrencyBalance.amount);

      return data;
    } catch (error) {
      return error.response;
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Dashboard/modules/finance.js